import React from 'react';
import DashboardContainer from '../components/dashboard/DashboardRedesign';

/**
 * Admin Dashboard Page
 *
 * Redesigned dashboard with:
 * - Category-based accordion sections (Daily Operations, Staff Management, etc.)
 * - Always-visible sidebar navigation on desktop
 * - Card/List view toggle with localStorage persistence
 * - Search with Ctrl+K keyboard shortcut (auto-expands matching sections)
 * - Pinned favorites section at the top
 * - Badge indicators on sections for leads and invitations count
 */
const Dashboard = () => {
  return <DashboardContainer />;
};

export default Dashboard;
